import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Field, Form } from 'react-final-form';
import classNames from 'classnames/bind';
import { array, arrayOf, bool, func, oneOf, oneOfType, shape, string } from 'prop-types';
import Search from "../../../Search";
import { CloseLinear } from "../../../icons";
import { InputBase } from "../../../internal/InputBase";
import { TextBase } from "../../../internal/TextBase";
import styles from './HeaderSearch.css';
var cx = classNames.bind(styles);
var themes = process.env.NODE_ENV !== "production" ? ['default', 'b2c', 'b2b'] : {};
export var HeaderSearch = function HeaderSearch(_ref) {
  var result = _ref.result,
      _onSubmit = _ref.onSubmit,
      onClose = _ref.onClose,
      mobile = _ref.mobile;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('root')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('input_wrapper')
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: function onSubmit(values) {
      return _onSubmit(values.search);
    },
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit;
      return /*#__PURE__*/React.createElement("form", {
        className: cx('form', {
          mobile: mobile
        }),
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement(Field, {
        name: "search"
      }, function (_ref3) {
        var input = _ref3.input;

        var commonProps = _objectSpread(_objectSpread({}, input), {}, {
          onChange: function onChange(event) {
            _onSubmit(event.target.value);

            input.onChange(event);
          },
          placeholder: 'Поиск...'
        });

        return mobile ? /*#__PURE__*/React.createElement(Search, _extends({}, commonProps, {
          classes: {
            root: cx('input_mobile')
          }
        })) : /*#__PURE__*/React.createElement(InputBase, _extends({}, commonProps, {
          className: cx('input')
        }));
      }));
    }
  }), onClose && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('close'),
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseLinear, null))), result && result.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: cx('popup')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('result')
  }, result.map(function (group) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, group.title && /*#__PURE__*/React.createElement("div", {
      className: cx('result_title')
    }, /*#__PURE__*/React.createElement(TextBase, {
      as: "span"
    }, group.title)), /*#__PURE__*/React.createElement("ul", {
      className: cx('result_list')
    }, group.items.map(function (_ref4) {
      var title = _ref4.title,
          href = _ref4.href,
          key = _ref4.key;
      return /*#__PURE__*/React.createElement("li", {
        key: key,
        className: cx('result_item')
      }, /*#__PURE__*/React.createElement("a", {
        href: href,
        className: cx('result_point')
      }, /*#__PURE__*/React.createElement(TextBase, {
        as: "span"
      }, title)));
    })));
  }))));
};
HeaderSearch.propTypes = process.env.NODE_ENV !== "production" ? {
  result: oneOfType([arrayOf(shape({
    title: string,
    items: shape({
      title: string,
      href: string,
      key: string
    })
  })), array]),
  // eslint-disable-next-line react/boolean-prop-naming
  withIcon: bool,
  mobile: bool,
  onSubmit: func.isRequired,
  onClose: func,
  onChange: func,
  theme: oneOf(themes),
  size: oneOf(['default', 'small'])
} : {};
HeaderSearch.defaultProps = {
  theme: 'default'
};